<template>
  <div>
    <b-dropdown @hide="onHide" id="notification" variant="link" class="m-md-2" no-caret right>
      <template slot="button-content">
        <i class="icon-bell"></i>
        <b-badge pill variant="danger">{{notificationAmount}}</b-badge>
      </template>
      <b-dropdown-header class="defaultCursor">{{$t('crm.Notification.header')}}
        <span v-if="this.notificationList.message.length > 0" @click="notifyAll" class="float-right clickableText" style="font-weight:400 !important;">{{$t('crm.Notification.setAllNotified')}}</span>
      </b-dropdown-header>
      <b-dropdown-item v-if="notificationAmount == null" class="no-content text-center ">{{$t('crm.Notification.noContentMsg')}}</b-dropdown-item>
      <!-- Message, Birthday, Appointment, renewal -->
      <template v-for="(ab,category,cd) in notificationList" v-if="category != 'commission'">
        <!-- Message -->
        <template v-if="category == 'message'">
          <b-dropdown-item @click="onClick(value.ID)" class="itemFontSize text-truncate message" style="max-width: 350px !important;" v-if="index < listQuantity[category]" v-for="(value, index) in notificationList[category]">
            <span class="float-left text-primary mr-2">●</span>{{value.content}}</b-dropdown-item>
        </template>
        <!-- Others -->
        <template v-else>
          <b-dropdown-item @click="NotificationRedirect(category,value)" class=" itemFontSize text-truncate" style="max-width: 350px !important;" v-if="index < listQuantity[category]" v-for="(value, index) in notificationList[category]"  :class="(clickableCategory.includes(category))?'':'defaultCursor' ">{{value.content}}</b-dropdown-item>
        </template>
      </template>
      <!-- Commission -->
      <b-dropdown-item @click="NotificationRedirect('commission', key)" class="defaultCursor itemFontSize" v-if="index < listQuantity.commission && permissionLevel < 3.5" v-for="(value, key, index) in notificationList.commission">
        {{$t(`crm.Notification.commission.${key}`)}}
        <b-badge variant="danger" class="float-right normalBabge">{{value}}</b-badge>
      </b-dropdown-item>
      <!-- Read More -->
      <b-dropdown-item @click="redirect('Notification List')" class="defaultCursor text-center py-1" style="background: #ECECEC !important">
        <span class="clickableText">{{$t('crm.Notification.more')}}</span>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import $ from 'jquery'
import Moment from 'moment';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'NotificationBubble',
  props: {
    sentBeforeDate: {
      type: Number,
      default: 1,
    }
  },
  data: function() {
    return {
      notificationList: {
        commission: [],
        appointment: [],
        birthday: [],
        message: [],
        renewal: [],
      },
      listQuantity: {
        commission: 2,
        appointment: 10,
        birthday: 10,
        message: 10,
        renewal: 10,
      },
      clickedItem: {
        ID: ""
      },
      clickableCategory:[
      'renewal',
      'appointment',
      'birthday'
      ]
    }
  },
  watch: {
    onChangeState(newData, oldData) {
      console.log(newData);
      if (newData == true) {
        this.getNotification();
      }
    },
  },
  created() {
    this.getNotification();
  },
  computed: {
    permissionLevel() {
      return this.$store.state.permissionLevel;
    },
    ...mapState({
      'onChangeState': state => state.Crm.notificationList.onChangeState,
    }),
    notificationAmount() {
      var amount = 0;
      for (var category in this.notificationList) {
        if (category == 'commission') {
          // let objLength =Object.keys( this.notificationList[category] ).length;
          // amount += objLength;

          if(this.permissionLevel>3.5){
            continue;
          }

          let obj = this.notificationList.commission;
          if (parseInt(obj.agentCommission) > 0) {
            amount += 1;
          }
          if (parseInt(obj.companyCommission) > 0) {
            amount += 1;
          }
          continue;
        } else {
          amount += this.notificationList[category].length;
        }
      }
      if (amount == 0) {
        return null;
      } else {
        return amount;
      }
    }
  },
  methods: {
    NotificationRedirect(category, value) {
      

      switch(category){
          case "commission":
          this.$router.push({
          name: 'Notification Router',
          params: { messageType: value,                    
                    currentCategory:"C"}
          })
          break;
          case "renewal":
          // console.log(value.formattedNextPaymentDate);
          // console.log(category);
          this.$router.push({
          name: 'Notification Router',
          params: { reminderDate: value.formattedNextPaymentDate,                    
                    currentCategory:"R"}
          })
          break;
          case "birthday":
          case "appointment":
          this.$router.push({
            path:'/crm/calendar',
          });
          break;

      }


    },
    getDateParams(type) {
      var params;
      let endDate = Moment().format('YYYY-MM-DD');
      let startDate = Moment().subtract(this.sentBeforeDate, 'd').format('YYYY-MM-DD');
      switch (type) {
        case "Object":
          params = {};
          params.startDate = startDate;
          params.endDate = endDate;
          break;

        default:
        case "Array":
          params = [];
          params.push({ key: 'startDate', value: startDate });
          params.push({ key: 'endDate', value: endDate });
          params.push({key:'notified',value:false});
          break;
      }
      return params;
    },

    onClick(ID) {
      console.log(ID);
      this.clickedItem.ID = ID;
    },
    onHide(event) {
      if (this.clickedItem.ID) {
        event.preventDefault();
        this.notifyByID(this.clickedItem.ID);
        this.clickedItem.ID = "";
      }
    },
    notifyByID(ID) {
      this.$store.dispatch('Crm/notifyMessageByID', this.clickedItem.ID).then((json) => {
        this.$store.commit('Crm/setNotificationOnChangeState', { state: true });
        // this.getNotification();
      }).catch((error) => {
        console.log(error);
      });
    },
    notifyAll() {
      let params = this.getDateParams('Object');
      this.$store.dispatch('Crm/notifyMessageByDate', params).then((json) => {
        this.$store.commit('Crm/setNotificationOnChangeState', { state: true });
        // this.getNotification();
      }).catch((error) => {
        console.log(error);
      });
    },
    redirect(destination) {
      this.$router.push({
        name: destination,
      });
    },
    getNotification() {
      if (this.permissionLevel == 7) {
        return;
      }
      let params = this.getDateParams('Array');
      this.$store.dispatch('Crm/getNotification', params).then((json) => {
        this.notificationList = json;
        this.$store.commit('Crm/setNotificationOnChangeState', { state: false });
      }).catch((error) => {
        console.log(error);
      });
    }
  },
  // getNotificationList(rawData) {
  //  console.log(rawData);
  // }
}

</script>
<style type="text/css">
div#notification div.dropdown-menu {
  min-width: 350px !important;
}

div#notification a.dropdown-item,
div#notification .dropdown-header {
  padding-right: 10px;
  padding-left: 10px !important;
}

div#notification a.dropdown-item.message:hover {
  background: #20a8d8 !important;
  color: #FFFFFF !important;
}

div#notification a.dropdown-item.message:focus {
  background: #FFFFFF;
}

div#notification a.dropdown-item:active {
  color: #181b1e !important;
  text-decoration: none;
  background-color: #f0f3f5 !important;
}

div#notification a.no-content.dropdown-item {
  background: #FFFFFF !important;
  color: #333333 !important;
}

.itemFontSize {
  font-size: 0.75rem !important;
}

.defaultCursor {
  cursor: default;
}

.clickableText {
  font-size: 0.8rem;
  color: #20a8d8;
  cursor: pointer;
}

.normalBabge {
  position: relative !important;
  margin-top: 4px !important;
  left: 0% !important;
}

</style>



// WEBPACK FOOTER //
// src/components/NotificationBubble.vue